export default {
  English: {
    //home
    "home.title": "Your attorney should speak your language!",
    "home.subtitle": "We have the proven passion, experience and tenacity to win.  Let us fight for you.",
    "home.freequote": "FREE CONSULTATION!",
    "home.bilingual": "Fluent in English & Spanish & French & Arabic ",
    "home.experience": "More than {{yearsOfExperience}} years of experience",

    //nav
    "nav.home": "Home",
    "nav.practice": "Areas of Practice",
    "nav.about": "About Us",
    "nav.contact": "Contact Us",

    //contact us
    "contactus.title": "Contact Us",
    "contactus.subtitle": "We maintain convenient hours in Dover, New Jersey with a friendly, efficient and competent staff of talented people who are all dedicated to providing assistance to our lawyers protecting our client’s interests. All of our staff members are bilingual.",
    "contactus.addresstitle": "My Office:",

    //footer
    "footer.allrightsreserved": "All rights reserved.",
    "footer.support": "Support",
    "footer.information": "Information",

  },
  Spanish: {
    //home
    "home.title": "Su abogada, en su idioma",
    "home.subtitle": "Cuando estás explicando los detalles de tu caso, es importante que tu abogada entienda cada detalle.",
    "home.freequote": "¡LA CONSULTA ES GRATIS!",
    "home.bilingual": "Hablo español fluidamente",
    "home.experience": "Mas de {{yearsOfExperience}} años de experiencia",

    //nav
    "nav.home": "Inicio",
    "nav.practice": "Áreas de Práctica",
    "nav.about": "Sobre Nosotros",
    "nav.contact": "Contáctanos",

    //contact us
    "contactus.title": "Contáctanos",
    "contactus.subtitle": "Mantenemos horas convenientes de oficina en Dover, New Jersey con un personal amigable, eficiente y competente que se dedican a proveer asistencia a los intereses de nuestros clientes. Cada miembro de nuestro personal es bilingüe.",
    "contactus.addresstitle": "Mi Officina:",

    //footer
    "footer.allrightsreserved": "Todos los derechos reservados",
    "footer.support": "Soporte",
    "footer.information": "Información",
  },
  French: {
    //home
    "home.title": "Votre avocate, dans votre langue",
    "home.subtitle": "Lorsque vous expliquez les détails de votre affaire, il est important que votre avocate comprenne chaque détail.",
    "home.freequote": "LA CONSULTATION EST GRATUITE !",
    "home.bilingual": "Nous parlons couramment français.",
    "home.experience": "Plus de {{yearsOfExperience}} ans d'expérience",

    //nav
    "nav.home": "Accueil",
    "nav.practice": "Domaines de pratique",
    "nav.about": "À propos de nous",
    "nav.contact": "Nous contacter",

    //contact us
    "contactus.title": "Nous contacter",
    "contactus.subtitle": "Nous avons des heures de bureau pratiques à Dover, New Jersey, avec un personnel amical, efficace et compétent qui s'engage à fournir une assistance aux intérêts de nos clients. Chaque membre de notre personnel est bilingue.",
    "contactus.addresstitle": "Mon bureau :",

    //footer
    "footer.allrightsreserved": "Tous droits réservés",
    "footer.support": "Support",
    "footer.information": "Information",    

  },
  Arabic:
  {
    //home
    "home.title": "محاميك من حيك",
    "home.subtitle": "شغف، خبرة وعناد مثبت للفوز. دعني أقاتل من أجلك.",
    "home.freequote": "استشارة مجانية!",
    "home.bilingual": "أنا أتحدث الفرنسية بطلاقة",
    "home.experience": "أكثر من {{yearsOfExperience}} سنوات من الخبرة",
    //nav
    "nav.home": "الرئيسية",
    "nav.practice": "مجالات التخصص",
    "nav.about": "من نحن",
    "nav.contact": "اتصل بنا",

    //contact us
    "contactus.title": "اتصل بنا",
    "contactus.subtitle": "نحن نحافظ على ساعات مريحة في دوفر، نيوجيرسي مع طاقم ودود وفعال ومؤهل من الناس الموهوبين الذين يعملون جميعًا على تقديم المساعدة لمحامينا في حماية مصالح عملائنا. جميع أعضاء فريق العمل لدينا يجيدون اللغتين.",
    "contactus.addresstitle": "مكتبي:",

    //footer
    "footer.allrightsreserved": "جميع الحقوق محفوظة.",
    "footer.support": "الدعم",
    "footer.information": "معلومات",        
  }
}

